import SlsInput from './SlsInput.vue';
import SlsSelect from './SlsSelect.vue';
import SlsDate from './SlsDate.vue';
import SlsInputNumber from './SlsInputNumber.vue';
import SlsTextarea from './SlsTextarea.vue';
import SlsSwitch from './SlsSwitch.vue';
/* import SlsCheckbox from './SlsCheckbox.vue';
import SlsRadio from './SlsRadio.vue';
import SlsCascader from './SlsCascader.vue';
import SlsDateRange from './SlsDateRange.vue';
import SlsDateYear from './SlsDateYear.vue';
import SlsDateMonth from './SlsDateMonth.vue';
import SlsDateWeek from './SlsDateWeek.vue';
import SlsTime from './SlsTime.vue';
import SlsTimeRange from './SlsTimeRange.vue';
import SlsTimeFixed from './SlsTimeFixed.vue';
import SlsTimeFixedRange from './SlsTimeFixedRange.vue';
import SlsDateTime from './SlsDateTime.vue';
import SlsDateTimeRange from './SlsDateTimeRange.vue';
import SlsEditor from './SlsEditor.vue'; */

export default {
  SlsInput,
  SlsInputNumber,
  SlsTextarea,
  // SlsCheckbox,
  // SlsRadio,
  SlsSwitch,
  SlsSelect,
  SlsDate,
  // SlsCascader,
  // SlsDateRange,
  // SlsDateYear,
  // SlsDateMonth,
  // SlsDateWeek,
  // SlsTime,
  // SlsTimeRange,
  // SlsTimeFixedRange,
  // SlsTimeFixed,
  // SlsDateTime,
  // SlsDateTimeRange,
  // SlsEditor,
};
